var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispositivosClara(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M15 1.2c1.56327596.02177096 3.06170434.62827769 4.2 1.7l.8-.8C18.68337733.75622761 16.88128134-.00102051 15-.00102051c-1.88128134 0-3.68337733.75724812-5 2.10102051l.8.8c1.13829566-1.07172231 2.63672404-1.67822904 4.2-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M11.7 3.7l.8.8c1.4-1.33333333 3.6-1.33333333 5 0l.8-.8c-.86468049-.89481275-2.05566797-1.40012543-3.3-1.40012543-1.24433203 0-2.43531951.50531268-3.3 1.40012543z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M15.55599976 12h2.22200012c1.16348266-.05456543 2.1542511.8372116 2.22200012 2v4c-.06774902 1.16278076-1.05851746 2.05456543-2.22200012 2H2.22200012C1.05851746 20.05456543.06774902 19.16278076 0 18v-4c.06774902-1.1627884 1.05851746-2.05456543 2.22200012-2h11.1110077V8h2.22299194v4zM2.22200012 18h15.55599976v-4H2.22200012v4z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 3.375,
    y: 14.625,
    fill: "rgb(255,255,255)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 7.313,
    y: 14.625,
    fill: "rgb(255,255,255)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 11.25,
    y: 14.625,
    fill: "rgb(255,255,255)",
    rx: 0,
    ry: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispositivosClara);
export default __webpack_public_path__ + "static/media/dispositivos_clara.6d276e327a657e172bc29ce38c312880.svg";
export { ForwardRef as ReactComponent };